module.exports = __webpack_public_path__ + "img/11.7693bb70.png";